import { MutationTree } from 'vuex';
import { SessionsState, Session } from './types';

export const mutations: MutationTree<SessionsState> = {
    setSessions(state, payload: any) {
        if (payload && payload.sessions) {
            state.sessions = payload.sessions;
        } else {
            state.sessions = [];
        }
        if (payload && payload.recents) {
            state.recents = payload.recents;
        } else {
            state.recents = [];
        }
        state.firstPull = false;
        console.log('set sessions', state.sessions, state.recents);
    },

    timerStarted(state, payload) {
        state.timer = payload.timer;
        state.destination = payload.destination;
        state.firstPull = true;
        console.log('timer started');
    },

    timerStopped(state) {
        state.timer = null;
        state.sessions = [];
        state.recents = [];
        state.destination = null;
        console.log('timer stopped');
    },

    sessionArrived(state, payload) {
        if (state.sessions != null) {
            const arrived = state.sessions.find((s) => {
                return s.id == payload;
            });
            state.sessions = state.sessions.filter((s) => {
                return s.id != payload;
            });
            if ((arrived) && (state.recents != null)) {
                state.recents.push(arrived);
            }
        }
    },

    sessionCleared(state, payload) {
        if (state.sessions != null) {
            state.sessions = state.sessions.filter((s) => {
                return s.id != payload;
            });
        }
        if (state.recents != null) {
            state.recents = state.recents.filter((s) => {
                return s.id != payload;
            });
        }
    },

    setPulling(state, payload) {
        state.pulling = payload;
    },

    newSession(state) {
        console.log('new session.. play a tune please');
    }
};
